import { Link } from "react-router-dom";
import { Phone, MessageSquare, ClipboardList } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useBusinessInfo } from "@/lib/useBusinessInfo";

export const StickyMobileCta = () => {
  const { t } = useLanguage();
  const biz = useBusinessInfo();

  return (
    <nav
      data-testid="sticky-mobile-cta"
      aria-label="Quick actions"
      className="fixed inset-x-0 bottom-0 z-[60] grid h-14 grid-cols-3 border-t border-white/10 bg-ink/95 backdrop-blur-xl md:hidden"
    >
      <a
        data-testid="sticky-call-btn"
        href={biz.phoneHref}
        className="flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-[0.15em] text-white transition-colors duration-300 active:text-gold"
      >
        <Phone className="h-4 w-4 text-gold" />
        {t.contact.call}
      </a>
      <a
        data-testid="sticky-text-btn"
        href={biz.smsHref}
        className="flex items-center justify-center gap-2 border-x border-white/10 text-[11px] font-black uppercase tracking-[0.15em] text-white transition-colors duration-300 active:text-gold"
      >
        <MessageSquare className="h-4 w-4 text-gold" />
        {t.contact.text}
      </a>
      <Link
        data-testid="sticky-bid-btn"
        to="/request-a-bid"
        className="flex items-center justify-center gap-2 bg-gold text-[11px] font-black uppercase tracking-[0.12em] text-ink transition-colors duration-300 active:bg-golddark"
      >
        <ClipboardList className="h-4 w-4" />
        {t.nav.stickyBid}
      </Link>
    </nav>
  );
};
